module.exports = __webpack_public_path__ + "img/cd106b4.png";